import { render, staticRenderFns } from "./codes-edit-tab.vue?vue&type=template&id=2d55a3ab&scoped=true"
import script from "./codes-edit-tab.vue?vue&type=script&lang=js"
export * from "./codes-edit-tab.vue?vue&type=script&lang=js"
import style0 from "./codes-edit-tab.vue?vue&type=style&index=0&id=2d55a3ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d55a3ab",
  null
  
)

export default component.exports